import { type DefaultError, type UseMutationOptions } from '@tanstack/react-query'
import { deleteField, doc, getFirestore, Timestamp, updateDoc } from 'firebase/firestore'

import { useOnrApi } from './useOnrApi.ts'

export type UpdateTransportRequestOnrApiMutationOptions<
  TData = unknown,
  TVariables extends { transportRequestId: string } = { transportRequestId: string },
  TError = DefaultError,
> = Omit<UseMutationOptions<TData, TError, TVariables, void>, 'mutationFn' | 'onMutate'>

export function useUpdateTransportRequestOnrApi<
  TData = unknown,
  TVariables extends { transportRequestId: string } = { transportRequestId: string },
  TError = DefaultError,
>({ type, ...options }: { type: string } & UpdateTransportRequestOnrApiMutationOptions<TData, TVariables, TError>) {
  return useOnrApi({
    type,
    ...options,
    onMutate: async (variables) => {
      const { transportRequestId, ...rest } = variables
      return updateDoc(doc(getFirestore(), `transportRequests/${transportRequestId}`), 'dashboardPendingRequest', {
        type,
        timestamp: Timestamp.now(),
        payload: rest,
      })
    },
    cleanUpAfterError: async ({ transportRequestId }) =>
      updateDoc(
        doc(getFirestore(), `transportRequests/${transportRequestId}`),
        'dashboardPendingRequest',
        deleteField()
      ),
  })
}
